export const churches = (state = [], { type, payload }) => {
  switch (type) {
    case 'SET_CHURCHES':
      return payload

    default:
      return state
  }
}
